import React from 'react';
import { getHistory } from '../utils/resultHistory';
import { getAllQuizzes } from '../data/quizRegistry';

const WEIGHTS: Record<string, number> = {
  'life-expectancy': 0.25,
  'dementia-risk': 0.20,
  'stress-index': 0.20,
  'sleep-health': 0.20,
  'mental-health': 0.15,
};

const AggregateScore: React.FC = () => {
  const quizzes = getAllQuizzes();
  const completedQuizzes: { quizId: string; lastScore: number }[] = [];

  quizzes.forEach((quiz) => {
    const history = getHistory(quiz.id);
    if (history.length > 0) {
      completedQuizzes.push({
        quizId: quiz.id,
        lastScore: history[0].lifeExpectancy,
      });
    }
  });

  if (completedQuizzes.length < 2) return null;

  let totalWeight = 0;
  let weightedSum = 0;

  completedQuizzes.forEach(({ quizId, lastScore }) => {
    const weight = WEIGHTS[quizId] || 0.2;
    totalWeight += weight;
    weightedSum += lastScore * weight;
  });

  const aggregateScore = Math.round(weightedSum / totalWeight);
  const completedCount = completedQuizzes.length;
  const totalCount = quizzes.length;

  return (
    <div style={{
      width: '100%',
      maxWidth: '500px',
      background: 'linear-gradient(135deg, #667eea, #764ba2)',
      borderRadius: '20px',
      padding: '24px',
      margin: '20px 0',
      textAlign: 'center',
      color: '#fff',
      boxShadow: '0 4px 15px rgba(102, 126, 234, 0.3)',
    }}>
      <div style={{ fontSize: '14px', opacity: 0.9, marginBottom: '8px' }}>
        🏆 종합 건강 점수
      </div>
      <div style={{ fontSize: '48px', fontWeight: 'bold', margin: '8px 0' }}>
        {aggregateScore}점
      </div>
      <div style={{ fontSize: '13px', opacity: 0.8 }}>
        {completedCount}/{totalCount}개 테스트 완료
      </div>
    </div>
  );
};

export default AggregateScore;
